<template>
  <div>
    <!-- <el-button type="primary" size="small" style="margin: 10px 5px" @click="SureUpload">确认上传</el-button>
    <p v-if="fileList.length > 0" style="margin: 5px 5px;color:#909399 ;">如果上传信息无误后,请点击确认上传后在进行下面操作</p> -->
    <el-upload ref="cjUpload" action="#" :list-type="type" :auto-upload="false" :limit="limit" :file-list="filearr"
      :on-change="OnChangeUpload" :on-exceed="handleExceed" multiple :on-progress="onProgress" :disabled="Isdisabled"
      :class="{ disUoloadSty: noneBtnDealImg }" :accept="accept ? accept :''"
      style="width: 95%;border: 2px solid #DCDFE6;padding: 15px 5px 10px;min-width: 165px;" :apiType="apiType"
      :on-remove="handleRemove" :show-file-list="type == 'text' ? false : true">
      <el-button v-if="type == 'text'" size="small" type="primary">点击上传</el-button>
      <i slot="default" class="el-icon-plus" v-else></i>

      <div slot="file" slot-scope="{file}" style="width: 100%;height: 100%;" v-if="type != 'text'">
        <el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" fit="fill"
          style="width: 100%;height: 100%;" :preview-src-list="scrList"></el-image>
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <!-- <span v-if="!disableds" class="el-upload-list__item-delete" @click="handleDownload(file)">
            <i class="el-icon-download"></i>
          </span> -->
          <span v-if="!disableds" class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>

      </div>
      <div style="width: 600px;" v-if="type == 'text' && fileList.length > 0">
        <div v-for="(file, index) in  fileList" :key="index">
          <el-button type="text" style="margin-left: 35px;display: inline-block;color: red;"
            @click="textFIlePreview(file, index)">
            {{ file.name }}
          </el-button>
          <el-button type="text" style="margin-left: 35px;display: inline-block;"
            @click.capture.stop="handleRemove(file)" v-if="file.name != ''">
            删除
          </el-button>
        </div>

      </div>
      <div style="width: 600px;" v-if="type == 'video' && fileList.length > 0">
          <div v-for="(file, index) in  fileList" :key="index" style="width: 200px;height:150px;overflow: hidden;position: relative;">
              <video :src="file.url"></video>    
              <div style="width: 50px;height: 50px;background-color:rgba(255, 5, 5,0.5);line-height: 50px;text-align: center;
              border-radius: 100%;font-size: 23px;color: white;position:absolute;top: -15px;right: -15px;"
               @click.capture.stop="handleRemove(file)" v-if="file.name != ''">
              ✖
              </div>
          </div>
      </div>
    </el-upload>

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt=""> -->
    <el-image ref="scrImg" id="scrimg" :src="dialogImageUrl" alt="" fit="fill" style="width: 100%;height: 0;"
      :preview-src-list="scrList"></el-image>
    <!-- </el-dialog> -->
  </div>
</template>

<script>
export default {
  name: 'cjUpload',
  components: {

  },
  props: {
    accept:{
      type: String,
      default: "",
    },
    apiType: {
      default: "img"

    },
    filearr: {
      type: Array,
    },
    limit: {
      type: Number,
      default: 1

    },
    type: {
      type: String,
      default: "picture-card",
    },
  },
  data() {
    return {
      maxLength: 0,
      loadings: '',
      dialogVisible: false,
      dialogImageUrl: '',
      noneBtnDealImg: false,
      Isdisabled: false,
      disableds: false,
      accessoryList: [],
      fileList: [],
      scrList: [],
    }
  },
  watch: {
    filearr: {
      handler(n, v) {
        this.fileList = n;
        if (this.fileList.length == this.limit) {
          this.Isdisabled = true;
          this.noneBtnDealImg = true;
        } else {
          this.Isdisabled = false;
          this.noneBtnDealImg = false;
        }

      },
      immediate: true,
      deep: true

    },
    fileList(n) {
      if (this.fileList.length == this.limit) {
        this.Isdisabled = true;
        this.noneBtnDealImg = true;
      } else {
        this.Isdisabled = false;
        this.noneBtnDealImg = false;
      }
    }
  },

  created() { },
  methods: {
    MoveTheCloud(file) {
      return new Promise((resolve, reject) => {
        var s3 = new AWS.S3({
          apiVersion: '2006-03-01',
          accessKeyId: "1U04U6B1SL3IJNAOIAMN",
          secretAccessKey: "qUj578mhXovjWGXQi3BiooJ9YQd5Ded0sfvQGWx4",
          endpoint: "http://eos-shanghai-2.cmecloud.cn",
          signatureVersion: 'v2',
          sslEnabled: false
        });
        if (file) {
          //console.log(file);
          const fileName = file.uid + file.lastModified
          const fileType = file.name.split('.')
          //console.log(fileType);
          var params = {
            Key: "file/" + fileName + '.' +  fileType[fileType.length-1],
            Bucket: "aojv",
            ContentType: file.type,
            ACL: "public-read",
            Body: file
          }
          s3.putObject(params, function (err, data) {
            //console.log(err,data);
            if(err) return alert('重新错误,请重新上传');
            const fileUrl = 'http://aojv.eos-shanghai-2.cmecloud.cn/file/' + fileName + '.' + fileType[fileType.length-1]
            //console.log(fileobj);
            return resolve(fileUrl)
            // results.innerHTML = err ? 'ERROR!' : 'UPLOADED.';
            //http://aojv.eos-shanghai-2.cmecloud.cn/file/chenjingtest1001.aac      
          });
        } else {
          alert('重新上传');
        }
      })

    },
    // 文本预览
    textFIlePreview(file, index) {
      console.log(file);
      this.$emit('textFIlePreview', index)
    },
    fileAllRemove() {
      this.$nextTick(() => {
        this.$refs.cjUpload.clearFiles()
        this.Isdisabled = false;
        this.noneBtnDealImg = false;
        this.fileList = []
        console.log(this.fileList);
      })

    },
    openLoading() {
      //loading请求等待
      this.loadings = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    async SureUpload() {
      const data = [];
      let Data = new FormData();
      this.accessoryList.forEach((item, index) => {
        if (item.raw) {
            data.push(this.MoveTheCloud(item.raw));
        }
      });
      this.openLoading()
      const res = await Promise.all(data);
      console.log(res);
      const url = [];
        res.forEach((item, index) => {
          url.push(item)
        })
      console.log("url====",url);
      this.loadings.close()
      this.$emit('fileChange', url)
      
    },
    uploadbf(file) {
    },
    onProgress(event, file, fileList) {
    },
    // 检验文件
    uploadFilesVerification(file, fileList) {
      let existFile = fileList.slice(0, fileList.length - 1).find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error('当前文件已经存在!');
        fileList.pop();
        return
      }
      this.accessoryList = fileList;
      this.fileList = fileList;
      this.SureUpload(file, fileList)
      console.log(fileList, this.fileList,);
    },
    async OnChangeUpload(file, fileList) {
      this.maxLength = 0;
      let length = fileList.length;
      this.maxLength = Math.max(length, this.maxLength);
      setTimeout(() => {
        if (length === this.maxLength) {
          console.log(this.maxLength);
          this.uploadFilesVerification(file, fileList)
        }
      }, 100)
    },
    submitUpload() {

    },
    handleRemove(file) {
      console.log(file);
      const url = this.fileList.findIndex(item => item.url === file.url)
      const uid = this.fileList.findIndex(item => item.uid === file.uid)

      if (url) {
        console.log('2');
        this.fileList.splice(url, 1)
        this.$emit('removeAfter', file.url)
        return
      } else {
        console.log('1');
        this.fileList.splice(uid, 1);
        this.$emit('removeAfter', file.url)
        return
      }
    },
    handlePictureCardPreview(file) {
      console.log(this.$refs.scrImg);
      this.dialogImageUrl = file.url;
      this.fileList.forEach(item => {
        this.scrList.push(item.url)
      })
      this.$refs.scrImg.clickHandler()
    },
    handleDownload(file) {
      console.log(file);
    },
    //限制上传附件
    handleExceed(files, fileList) {
      console.log(files);
      const val = this.limit - this.fileList.length
      if (val < files.length) {
        this.$message.warning(`当前限制选择 ${this.limit} 个文件，一共选择了 ${files.length + this.fileList.length} 个文件`)
        return
      }
      const size = files.size / 1024 / 1024;
      if (files.length > this.limit) {
        this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件`)
        return
      }
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        return;
      }

    },

  }
}
</script>

<style scoped>
.disUoloadSty /deep/ .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}
</style>
